/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 202309d9 (Tue Mar 17 17:42:15 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface MembersInformation
 */
export interface MembersInformation {
  /**
   *
   * @type string
   * @memberof MembersInformation
   */
  id?: string
  /**
   *
   * @type string
   * @memberof MembersInformation
   */
  email?: string
  /**
   *
   * @type string
   * @memberof MembersInformation
   */
  company?: string
  /**
   *
   * @type string
   * @memberof MembersInformation
   */
  name?: string
  /**
   *
   * @type string
   * @memberof MembersInformation
   */
  privateMessage?: string
  /**
   *
   * @type string
   * @memberof MembersInformation
   */
  status?: string
}

export function MembersInformationFromJSON(json: any): MembersInformation {
  return MembersInformationFromJSONTyped(json, false)
}

export function MembersInformationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MembersInformation {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    email: !exists(json, 'email') ? undefined : json['email'],
    company: !exists(json, 'company') ? undefined : json['company'],
    name: !exists(json, 'name') ? undefined : json['name'],
    privateMessage: !exists(json, 'privateMessage')
      ? undefined
      : json['privateMessage'],
    status: !exists(json, 'status') ? undefined : json['status'],
  }
}

export function MembersInformationToJSON(
  value?: MembersInformation | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    email: value.email,
    company: value.company,
    name: value.name,
    privateMessage: value.privateMessage,
    status: value.status,
  }
}
